module.exports = {"id":"171189","name":"Aythami Artiles","rating":"73","photo":"./data/images/photos/1/171189.png","club":{"name":"Córdoba CF","logo":"./data/images/clubs/CordobaCF.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AythamiArtiles0.json
// module id = 511
// module chunks = 0